import { Box, HStack } from '@/components/sgBootstrapReactWrapper';
import type { Person } from '@/model/Person';
import { personsSlice } from '@/store/persons/slice';
import { formatCountryName } from '@/utils/country';
import { formatDate } from '@/utils/date';
import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { SubtextEmphasizer } from '../common/SubtextEmphasizer';
import { AmlLevelBadge } from './AmlLevelBadge';

type Props = {
  person: Person;
  emphasizedText: string;
};

function display(property: string | null | undefined): string {
  return property ?? '-';
}

export const PersonCard = ({
  person: { personId, lastName, firstName, birthName, birthDate, residenceCountry, amlLevel },
  emphasizedText,
}: Props) => {
  const { locale } = useIntl();
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(personsSlice.actions.setPersonIdDisplayedInDrawer(personId));
  }, [personId, dispatch]);

  return (
    <div
      className="row px-12px py-16px border-bottom w-100 g-8px"
      style={{ cursor: 'pointer' }}
      data-e2e="person-card"
      onClick={handleClick}
    >
      <div className="col-6">
        <HStack className="fw-medium text-nowrap" horizontalAlignment="start">
          <em className="icon text-secondary pe-8px">person</em>
          <Box className="text-nowrap">
            {personId}&nbsp;-&nbsp;{display(firstName)}&nbsp;
          </Box>
          <SubtextEmphasizer content={display(lastName)} sub={emphasizedText} />
          {birthName && (
            <>
              , <FormattedMessage id="born" /> {birthName}
            </>
          )}
        </HStack>
      </div>

      <HStack className="col-2" horizontalAlignment="end">
        {birthDate && (
          <HStack className="fs-14 text-secondary" gap="4px">
            <em className="icon icon-sm">cake</em>
            <span>{formatDate(birthDate)}</span>
          </HStack>
        )}
      </HStack>
      <HStack className="col-2" horizontalAlignment="start">
        {residenceCountry && (
          <HStack className="fs-14 text-secondary" gap="4px">
            <em className="icon icon-sm">home</em>
            <span>{formatCountryName(residenceCountry, locale)}</span>
          </HStack>
        )}
      </HStack>
      <HStack className="col-2" horizontalAlignment="end">
        {amlLevel ? <AmlLevelBadge amlLevel={amlLevel} /> : '-'}
      </HStack>
    </div>
    // <HStack
    //   fullWidth
    //   horizontalAlignment="start"
    //   gap="8px"
    //   className="px-12px py-16px  border-bottom w-100"
    //   data-e2e="person-card"
    // >
    //   <em className="icon text-secondary">person</em>
    //   <HStack verticalAlignment="center" gap="8px" className="flex-grow-1">
    //     <HStack className="fw-medium" gap="4px">
    //       <Box className="text-nowrap">
    //         {personId}&nbsp;-&nbsp;{display(firstName)}
    //       </Box>
    //       {<SubtextEmphasizer content={display(lastName)} sub={emphasizedText} />}{' '}

    //       {birthName && (
    //         <>
    //           (
    //           <FormattedMessage id="born" />
    //           {birthName})
    //         </>
    //       )}
    //     </HStack>

    //     {birthDate && (
    //       <HStack className="fs-14 text-secondary" gap="4px">
    //         <em className="icon icon-sm">cake</em>
    //         <span>{formatDate(parse(birthDate, 'dd/MM/yyyy', 0), { dateStyle: 'medium' })}</span>
    //       </HStack>
    //     )}

    // {residenceCountry && (
    //   <HStack className="fs-14 text-secondary" gap="4px">
    //     <em className="icon icon-sm">home</em>
    //     <span>{formatCountryName(residenceCountry, locale)}</span>
    //   </HStack>
    // )}

    // {amlLevel ? (
    //   <span
    //     className={clsx(
    //       'badge',
    //       'badge-md',
    //       'rounded-pill',
    //       `badge-discreet-${colorForPersonAmlLevel[amlLevel]}`,
    //     )}
    //   >
    //     <FormattedMessage id={`person.amlLevel.${amlLevel}`} />
    //   </span>
    // ) : (
    //   '-'
    // )}
    //   </HStack>
    // </HStack>
  );
};
